module.exports = __webpack_public_path__ + "static/media/logo-icon.fd5eae98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo/logo-icon.svg
// module id = 390
// module chunks = 0